module.exports = __webpack_public_path__ + "img/27.adb5281f.svg";